import React, { useEffect } from "react"
import { Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { DataGrid } from "@material-ui/data-grid"
import { DeleteOutline } from "@material-ui/icons"
// Components
import Topbar from "../../components/Topbar/Topbar"
import Sidebar from "../../components/Sidebar/Sidebar"
// Data
import { deletePageContent, getPageContents } from "../../redux/apiCalls"
// Styles
import {
   Container,
   GridWrapper,
   Main,
   Wrapper,
   StyledLink,
   StyledButton,
   StyledIcon,
   Action,
   TitleWrapper,
   Title,
   TitleButton,
} from "./PageContentList.styles"

const PageContentList = () => {
   const dispatch = useDispatch()
   const pageContents = useSelector((state) => state.pageContent.pageContents)

   useEffect(() => {
      getPageContents(dispatch)
   }, [dispatch])

   const handleDelete = (id) => {
      deletePageContent(id, dispatch)
   }

   const columns = [
      { field: "_id", headerName: "ID", width: 210 },
      { field: "page", headerName: "Page", width: 210 },
      { field: "section", headerName: "Section", width: 140 },
      { field: "titleFr", headerName: "Title FR", width: 210 },
      { field: "titleEn", headerName: "Title EN", width: 210 },
      {
         field: "action",
         headerName: "Action",
         width: 180,
         renderCell: (params) => {
            return (
               <Action>
                  <StyledLink to={"/pageContent/" + params.row._id}>
                     <StyledButton>Edit</StyledButton>
                  </StyledLink>
                  <StyledIcon>
                     <DeleteOutline
                        onClick={() => handleDelete(params.row._id)}
                        color="secondary"
                     />
                  </StyledIcon>
               </Action>
            )
         },
      },
   ]

   const validPageContents = pageContents.filter(
      (pageContent) => pageContent && pageContent._id
   )

   return (
      <>
         <Topbar />
         <Container>
            <Wrapper>
               <Sidebar />
            </Wrapper>
            <Main>
               <TitleWrapper>
                  <Title>Page Contents List</Title>
                  <Link to="/newPageContent">
                     <TitleButton>Create</TitleButton>
                  </Link>
               </TitleWrapper>
               <GridWrapper>
                  <DataGrid
                     rows={validPageContents}
                     columns={columns}
                     sortModel={[{ field: "page", sort: "asc" }]}
                     initialState={{
                        sorting: {
                           sortModel: [{ field: "page", sort: "asc" }],
                        },
                     }}
                     getRowId={(row) => row?._id}
                     disableSelectionOnClick
                     pageSize={50}
                     checkboxSelection
                     autoHeight
                  />
               </GridWrapper>
            </Main>
         </Container>
      </>
   )
}

export default PageContentList
